module.exports = __webpack_public_path__ + "static/media/icon_barbecue.88176d76.svg";